import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { theme } from '../../styles/theme';

const ScrollButton = styled.button<{ show: boolean }>`
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${theme.colors.gradient.gold};
  color: ${theme.colors.secondary};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  box-shadow: ${theme.shadows.medium};
  z-index: ${theme.zIndex.dropdown};
  transition: ${theme.transitions.medium};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) => (show ? 'translateY(0)' : 'translateY(100px)')};
  pointer-events: ${({ show }) => (show ? 'all' : 'none')};
  
  &:hover {
    transform: ${({ show }) => (show ? 'translateY(-5px)' : 'translateY(100px)')};
    box-shadow: ${theme.shadows.large}, ${theme.shadows.glow};
  }
  
  &:focus {
    outline: none;
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    right: 20px;
    bottom: 20px;
    width: 40px;
    height: 40px;
  }
`;

const ScrollToTop: React.FC = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollHeight = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', checkScrollHeight);
    return () => window.removeEventListener('scroll', checkScrollHeight);
  }, [showScroll]);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ScrollButton 
      show={showScroll} 
      onClick={scrollTop}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <FontAwesomeIcon icon={faChevronUp} />
    </ScrollButton>
  );
};

export default ScrollToTop; 